module.exports = __webpack_public_path__ + "img/airbus-st-martine.3ed565e4.jpg";